export abstract class ApiError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'ApiError';
  }
}

function formatErrorDetails(details?: Record<string, any>): string | null {
  if (!details?.detail || !Array.isArray(details.detail)) {
    return null;
  }

  const formattedDetails = details.detail
    .map(err => {
      // Safely access loc and msg
      const location = (err.loc || []).slice(1).join('.');
      const message = err.msg || 'Invalid value';
      return `${location}: ${message}`;
    })
    .join('; ');

  return formattedDetails || null;
}

export class ValidationError extends ApiError {
  constructor(message: string) {
    super(message);
  }
}

export class NetworkError extends ApiError {
  constructor(message: string) {
    super(message);
  }
}

export class AuthenticationError extends ApiError {
  constructor(message: string) {
    super(message);
  }
}

export class ApiResponseError extends ApiError {
  constructor(
    message: string,
    public statusCode?: number,
    public details?: Record<string, any>
  ) {
    const formattedMessage = formatErrorDetails(details);
    // Use the formatted message if available, otherwise fallback to the original message.
    // If the original message is '[object Object]', prefer the formatted one even if it's null,
    // which will then be handled by a default in the super constructor or consumer.
    super(formattedMessage || (message === '[object Object]' ? 'A apărut o eroare de validare.' : message));
    this.name = 'ApiResponseError';
  }
} 